(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["728-dome-spinner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dome-portal')) {
  class DomePortal extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.video = this.querySelector('video');
      this.animated = this.querySelector('.dome-portal__animated');
      this.staticLogo = this.querySelector('.dome-portal__static');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = this.dataset.enableMotion === 'true';
      this.pageHidden = false;
      this.failed = false;
      this.logoFailed = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.addEventListener('playing', () => {
        if (!this.canPlay()) { this.video.pause(); return; }
        this.dataset.motion = 'on';
        this.startLogo();
      }, options);
      this.video.addEventListener('pause', () => {
        this.dataset.motion = 'off';
        this.stopLogo();
      }, options);
      this.video.addEventListener('error', () => { this.failed = true; this.showPoster(); }, options);
      this.animated.addEventListener('load', () => {
        if (this.canPlay() && !this.video.paused) {
          this.animated.hidden = false;
          this.staticLogo.hidden = true;
        }
      }, options);
      this.animated.addEventListener('error', () => {
        if (!this.animated.getAttribute('src')) return;
        this.logoFailed = true;
        this.stopLogo();
      }, options);
      this.motionListener = () => this.sync();
      this.reduced.addEventListener('change', this.motionListener, options);
      document.addEventListener('visibilitychange', this.motionListener, options);
      window.addEventListener('pagehide', () => {
        this.pageHidden = true;
        this.showPoster();
      }, options);
      window.addEventListener('pageshow', () => {
        this.pageHidden = false;
        this.sync();
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.alignInk());
      this.resizeObserver.observe(this.querySelector('.dome-portal__frame'));
      document.fonts?.ready.then(() => { if (this.isConnected) this.alignInk(); });
      this.alignInk();
      this.sync();
    }
    alignInk() {
      const ctx = document.createElement('canvas').getContext('2d');
      for (const link of this.querySelectorAll('.dome-portal__link')) {
        const ink = link.querySelector('.dome-portal__ink');
        const label = link.querySelector('.dome-portal__label');
        const style = getComputedStyle(link);
        ctx.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        const m = ctx.measureText(label.textContent);
        const lineHeight = parseFloat(style.fontSize);
        const baseline = (lineHeight - m.fontBoundingBoxAscent - m.fontBoundingBoxDescent) / 2 + m.fontBoundingBoxAscent;
        const arrow = ink.querySelector('svg').getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(ink).gap);
        const groupWidth = label.getBoundingClientRect().width + gap + arrow;
        const arrowTop = (lineHeight - arrow) / 2 + arrow * (4 - .65) / 16;
        const arrowBottom = (lineHeight - arrow) / 2 + arrow * (12 + .65) / 16;
        const left = Math.min(-m.actualBoundingBoxLeft, groupWidth - arrow + arrow * (4 - .65) / 16);
        const right = Math.max(m.actualBoundingBoxRight, groupWidth - arrow + arrow * (12 + .65) / 16);
        const top = Math.min(baseline - m.actualBoundingBoxAscent, arrowTop);
        const bottom = Math.max(baseline + m.actualBoundingBoxDescent, arrowBottom);
        ink.style.setProperty('--ink-x', `${groupWidth / 2 - (left + right) / 2}px`);
        ink.style.setProperty('--ink-y', `${lineHeight / 2 - (top + bottom) / 2}px`);
      }
    }
    canPlay() { return this.enabled && !this.pageHidden && !this.failed && !this.reduced.matches && !document.hidden; }
    startLogo() {
      if (this.logoFailed || !this.canPlay()) return;
      if (!this.animated.getAttribute('src')) this.animated.src = this.animated.dataset.src;
      if (this.animated.complete && this.animated.naturalWidth) {
        this.animated.hidden = false;
        this.staticLogo.hidden = true;
      }
    }
    stopLogo() {
      this.animated.hidden = true;
      this.staticLogo.hidden = false;
      this.animated.removeAttribute('src');
    }
    showPoster() {
      this.video.pause();
      this.dataset.motion = 'off';
      this.stopLogo();
    }
    sync() {
      if (!this.canPlay()) { this.showPoster(); return; }
      if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
      this.video.play().catch(error => {
        if (error.name === 'AbortError' || !this.canPlay()) return;
        this.failed = true;
        this.showPoster();
      });
    }
    disconnectedCallback() {
      this.video?.pause();
      this.stopLogo();
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  }
  customElements.define('dome-portal', DomePortal);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["728-environment"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('environment-portal')) {
  class EnvironmentPortal extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.video = this.querySelector('video');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = this.dataset.enableMotion === 'true';
      this.chamber = this.classList.contains('environment--chamber');
      this.requested = this.enabled;
      this.failed = false;
      this.toggle = this.querySelector('.environment__motion');
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.addEventListener('playing', () => {
        if (!this.canPlay()) { this.video.pause(); return; }
        this.dataset.videoReady = 'true';
        this.dataset.motion = 'on';
        this.updateControl();
      }, options);
      this.video.addEventListener('pause', () => {
        this.dataset.motion = 'off';
        this.updateControl();
      }, options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.showPoster();
      }, options);
      this.motionListener = () => this.sync();
      if (this.reduced.addEventListener) {
        this.reduced.addEventListener('change', this.motionListener, options);
      } else {
        this.reduced.addListener(this.motionListener);
      }
      document.addEventListener('visibilitychange', () => this.sync(), options);
      if (this.chamber) {
        if (this.toggle) {
          this.toggle.hidden = !this.enabled;
          this.toggle.addEventListener('click', () => {
            if (this.failed) {
              this.failed = false;
              this.requested = true;
              this.video.removeAttribute('src');
            } else {
              this.requested = !this.requested;
            }
            this.sync();
          }, options);
        }
        this.fitNavigation();
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.fitNavigation());
          this.resizeObserver.observe(this);
          this.querySelectorAll('.environment__links a').forEach(link => this.resizeObserver.observe(link));
        }
        window.addEventListener('resize', () => this.fitNavigation(), options);
        this.querySelector('.environment__poster').addEventListener('load', () => this.fitNavigation(), options);
        document.fonts?.ready.then(() => { if (this.isConnected) this.fitNavigation(); });
      }
      this.sync();
    }
    fitNavigation() {
      const nav = this.querySelector('.environment__links');
      const links = [...nav.querySelectorAll('a')];
      const gap = parseFloat(getComputedStyle(nav).columnGap) || 0;
      const required = links.reduce((width, link) => width + link.getBoundingClientRect().width, 0) + gap * (links.length - 1);
      const frameHeight = this.querySelector('.environment__poster').getBoundingClientRect().height;
      const horizontalFit = required <= this.clientWidth - 24;
      const twoRowFit = Math.max(...links.map(link => link.getBoundingClientRect().width)) <= this.clientWidth * .45;
      const fit = (this.dataset.layout === 'B' ? twoRowFit : horizontalFit) && frameHeight >= 300 ? 'row' : 'below';
      if (this.dataset.chamberFit !== fit) this.dataset.chamberFit = fit;
    }
    canPlay() {
      return this.enabled && this.requested && !this.failed && !this.reduced.matches && !document.hidden;
    }
    updateControl() {
      if (!this.toggle) return;
      this.toggle.disabled = this.reduced.matches;
      const label = this.reduced.matches ? 'reducedLabel' : this.failed ? 'retryLabel' : this.video.paused ? 'playLabel' : 'pauseLabel';
      this.toggle.setAttribute('aria-label', this.toggle.dataset[label]);
      this.toggle.title = this.toggle.dataset[label];
      this.toggle.dataset.controlState = this.reduced.matches ? 'reduced' : this.failed ? 'error' : this.video.paused ? 'paused' : 'playing';
    }
    showPoster() {
      this.video.pause();
      this.dataset.videoReady = 'false';
      this.dataset.motion = 'off';
      this.updateControl();
    }
    sync() {
      if (!this.canPlay()) { this.showPoster(); return; }
      if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
      this.video.play().catch(error => {
        if (error.name === 'AbortError' || !this.canPlay()) return;
        this.failed = true;
        this.showPoster();
      });
      this.updateControl();
    }
    disconnectedCallback() {
      this.video?.pause();
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      if (this.reduced && !this.reduced.removeEventListener) this.reduced.removeListener(this.motionListener);
    }
  }
  customElements.define('environment-portal', EnvironmentPortal);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["728-threshold"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('threshold-portal')) {
    class ThresholdPortal extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.toggle = this.querySelector('.threshold__motion');
        this.motionState = this.querySelector('.threshold__motion-state');
        this.reducedMessage = this.querySelector('.threshold__reduced-message');
        this.enabled = this.dataset.enableMotion === 'true';
        this.motionRequested = this.enabled;
        this.video = this.querySelector('.threshold__video');
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.addEventListener('playing', () => {
          if (this.dataset.motion !== 'on' || document.hidden) { this.video.pause(); return; }
          this.dataset.videoReady = 'true';
        }, options);
        this.video.addEventListener('error', () => {
          this.dataset.videoReady = 'false';
          this.video.pause();
        }, options);
        document.addEventListener('visibilitychange', () => this.syncVideo(), options);
        this.applyMotion();
        this.toggle.addEventListener('click', () => {
          this.motionRequested = !this.motionRequested;
          this.applyMotion();
        }, options);
        this.reducedMotion.addEventListener('change', () => this.applyMotion(), options);
        this.addEventListener('pointermove', event => {
          if (this.dataset.motion !== 'on' || !this.finePointer.matches || event.pointerType === 'touch') return;
          const rect = this.getBoundingClientRect();
          const x = Math.max(-6, Math.min(6, ((event.clientX - rect.left) / rect.width - .5) * 12));
          const y = Math.max(-4, Math.min(4, ((event.clientY - rect.top) / rect.height - .5) * 8));
          this.style.setProperty('--threshold-x', `${x.toFixed(2)}px`);
          this.style.setProperty('--threshold-y', `${y.toFixed(2)}px`);
        }, options);
        this.addEventListener('pointerleave', () => this.resetPosition(), options);
      }
      applyMotion() {
        const active = this.motionRequested && this.enabled && !this.reducedMotion.matches;
        this.toggle.hidden = !this.enabled;
        this.toggle.disabled = this.reducedMotion.matches;
        if (this.reducedMotion.matches) this.toggle.setAttribute('aria-describedby', this.reducedMessage.id);
        else this.toggle.removeAttribute('aria-describedby');
        this.dataset.motion = active ? 'on' : 'off';
        this.toggle.setAttribute('aria-pressed', String(active));
        this.motionState.textContent = active ? this.toggle.dataset.onLabel : this.toggle.dataset.offLabel;
        this.resetPosition();
        this.syncVideo();
      }
      syncVideo() {
        if (!this.video) return;
        if (this.dataset.motion !== 'on' || document.hidden) { this.video.pause(); return; }
        if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
        this.video.play().catch(() => {
          if (this.video.readyState < 2) this.dataset.videoReady = 'false';
        });
      }
      resetPosition() {
        this.style.setProperty('--threshold-x', '0px');
        this.style.setProperty('--threshold-y', '0px');
      }
      disconnectedCallback() { this.video?.pause(); this.abortController?.abort(); }
    }
    customElements.define('threshold-portal', ThresholdPortal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
